import React from "react";
import { formatNumber, formatPercent } from "~/utility/volby2026";

type Candidate = {
  name: string;
  parties: string;
  votes: number;
  votes_pct: number;
};

type Props = {
  candidates: Candidate[];
};

const CandidateBarList = ({ candidates }: Props) => {
  const sorted = [...candidates].sort((a, b) => (b.votes_pct || 0) - (a.votes_pct || 0));

  return (
    <div className="v26-bar-list">
      {sorted.map((c, i) => (
        <div className="v26-bar-row" key={i}>
          <div className="v26-bar-label">
            {c.name} <span className="v26-bar-parties">{c.parties}</span> –{" "}
            {formatPercent(c.votes_pct)} | {formatNumber(c.votes)} hlasov
          </div>
          <div className="v26-bar-track">
            <div
              className={"v26-bar-fill" + (i === 0 ? " leader" : "")}
              style={{ width: Math.max(0, Math.min(100, c.votes_pct || 0)) + "%" }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CandidateBarList;
